import { render } from "./ChatBotModePage.vue?vue&type=template&id=7ae0211f&scoped=true&ts=true"
import script from "./ChatBotModePage.vue?vue&type=script&lang=ts"
export * from "./ChatBotModePage.vue?vue&type=script&lang=ts"

import _style_0 from "./ChatBotModePage.vue?vue&type=style&index=0&id=7ae0211f&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-7ae0211f"]])

export default __exports__